export const MAX_FILTER_VALUES = 1000;

export const hasValueLimit = (interpreter?: { type?: string }): boolean =>
  interpreter?.type !== 'number' && interpreter?.type !== 'date';
